import Vue from 'vue'
import Router from 'vue-router'
import VueGtm from 'vue-gtm';

import Fees from './views/Fees'
import PageNotFound from './views/PageNotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: '/callback/:quoteId/:salesUid',
      name: 'callback',
      component: () => import(/* webpackChunkName: "callback" */ './views/Callback.vue'), meta: { title: 'Request a callback' }
    },
    {
      path: '/callbackAcknowledge/:quoteId/:salesUid',
      name: 'callbackAcknowledge',
      component: () => import(/* webpackChunkName: "callbackAcknowledge" */ './views/CallbackAcknowledge.vue'), meta: { title: 'Thank you for requesting a callback' }
    },
    {
      path: '/companyAdd/:quoteId/:salesUid',
      name: 'companyAdd',
      component: () => import(/* webpackChunkName: "companyAdd" */ './views/CompanyAdd.vue'), meta: { title: 'Add company' }
    },
    {
      path: '/fees',
      alias: '/',
      name: 'fees',
      component: Fees, meta: { title: 'Conveyancing fees' }
    },
    {
      path: '/individualAdd/:quoteId/:salesUid',
      name: 'individualAdd',
      component: () => import(/* webpackChunkName: "individualAdd" */ './views/IndividualAdd.vue'), meta: { title: 'Add individual' }
    },
    {
      path: '/instruct/:quoteId/:salesUid',
      name: 'instruct',
      component: () => import(/* webpackChunkName: "instruct" */ './views/Instruct.vue'), meta: { title: 'Let us help you today' }
    },
    {
      path: '/instructionConfirmation/:quoteId/:salesUid',
      name: 'instructionConfirmation',
      component: () => import(/* webpackChunkName: "instructionConfirmation" */ './views/InstructionConfirmation.vue'), meta: { title: 'Instruction confirmation' }
    },
    {
      path: '/lease',
      name: 'lease',
      component: () => import(/* webpackChunkName: "lease" */ './views/Lease.vue'), meta: { title: 'Lease extension' }
    },
    {
      path: '/mortgage',
      name: 'mortgage',
      component: () => import(/* webpackChunkName: "mortgage" */ './views/Mortgage.vue'), meta: { title: 'Remortgage' }
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: PageNotFound
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: () => import(/* webpackChunkName: "purchase" */ './views/Purchase.vue'), meta: { title: 'Purchase of property' }
    },
    {
      path: '/quotation/:quoteId/:salesUid',
      name: 'quotation',
      component: () => import(/* webpackChunkName: "quotation" */ './views/Quotation.vue'), meta: { title: 'Quotation' }
    },
    {
      path: '/sale',
      name: 'sale',
      component: () => import(/* webpackChunkName: "sale" */ './views/Sale.vue'), meta: { title: 'Sale of property' }
    },
    {
      path: '/saleAndPurchase',
      name: 'saleAndPurchase',
      component: () => import(/* webpackChunkName: "saleAndPurchase" */ './views/SaleAndPurchase.vue'), meta: { title: 'Sale and Purchase' }
    },
    {
      path: '/thanks/:quoteId/:salesUid',
      name: 'thanks',
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue'), meta: { title: 'Your request has been received' }
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: () => import(/* webpackChunkName: "transfer" */ './views/Transfer.vue'), meta: { title: 'Transfer of equity' }
    },
    {
      path: '/recentQuotes',
      name: 'recentQuotes',
      component: () => import(/* webpackChunkName: "recentQuotes" */ './views/RecentQuotes.vue'), meta: { title: 'Recent quotes' }
    },
    {
      path: '/quotation.xhtml',
      beforeEnter(to, from, next) { next({ name: 'quotation', params: { quoteId: to.query.quoteId, salesUid: to.query.salesUid } }) }
    },
    {
      path: '/instruct.xhtml',
      beforeEnter(to, from, next) { next({ name: 'instruct', params: { quoteId: to.query.quoteId, salesUid: to.query.salesUid } }) }
    },
    {
      path: '/thanks.xhtml',
      beforeEnter(to, from, next) { next({ name: 'thanks', params: { quoteId: to.query.quoteId, salesUid: to.query.salesUid } }) }
    },
    { path: '/sale.xhtml', redirect: { name: 'sale' } },
    { path: '/purchase.xhtml', redirect: { name: 'purchase' } },
    { path: '/saleAndPurchase.xhtml', redirect: { name: 'saleAndPurchase' } },
    { path: '/transfer.xhtml', redirect: { name: 'transfer' } },
    { path: '/mortgage.xhtml', redirect: { name: 'mortgage' } },
    { path: '/lease.xhtml', redirect: { name: 'lease' } },
    { path: "*", redirect: { name: 'notfound' } }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

Vue.use(VueGtm, {
  id: 'GTM-WV76KBJ',
  enabled: true,
  debug: false,
  vueRouter: router
});

export default router